import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import ProjectItemCard from './ProjectItemCard.tsx';
import ProjectModalNew from './ProjectModalNew.tsx';
import ProjectQuestions from '../../../Dashboard/project/ProjectById/ProjectQuestions';
import ProjectAnswer from '../../../Dashboard/project/ProjectById/ProjectAnswer';
import { getProjectQuestions, openMainModal } from '../../../../store/actions';
import {
  buildNavigationParams,
  type ProfileGestionSection,
} from '../../../../utils/navigationHelpers.ts';

interface ProjectCardWithLogicProps {
  project: {
    id: string | number;
    name: string;
    description?: string;
    zone?: string;
    startDate?: string;
    endDate?: string;
    createdAt?: string;
    proyecto_images?: Array<{ image: string }>;
  };
  myPerson: boolean;
  userData: any;
  projectQuestions: any;
  getProjectQuestions: (id: string | number) => void;
  openMainModal: (config: any) => void;
  currentTab?: string;
  gestionNavSection?: ProfileGestionSection | null;
}

const ProjectCardWithLogic: React.FC<ProjectCardWithLogicProps> = ({
  project,
  myPerson,
  userData,
  projectQuestions,
  getProjectQuestions,
  openMainModal,
  currentTab,
  gestionNavSection = null,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showProject, setShowProject] = useState(false);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const [questionToAnswer, setQuestionToAnswer] = useState<any>(null);

  useEffect(() => {
    getProjectQuestions(project.id);
  }, [project.id, getProjectQuestions]);

  const projectQuestionsForItem = projectQuestions?.[project.id] || [];
  const questionsNotAnswered = projectQuestionsForItem.filter((question: any) => 
    !question?.answer || question.answer.trim().length === 0
  );
  const totalQuestions = projectQuestionsForItem.length;

  const handleEdit = () => {
    const isFromProfile = location.pathname.startsWith('/perfil/');
    if (isFromProfile && myPerson && userData && currentTab) {
      const userName = userData.type === "COMPANY" 
        ? userData.razon_social 
        : `${userData.name} ${userData.last_name}`;
      const sectionForNav =
        currentTab === 'Gestión' ? gestionNavSection ?? 'proyectos' : null;
      const params = buildNavigationParams(
        currentTab as string,
        String(userData.id),
        userName,
        sectionForNav
      );
      navigate(`/obrasprivadas/edit/${project.id}${params}`);
    } else {
      navigate(`/obrasprivadas/edit/${project.id}`);
    }
  };

  const handleView = () => {
    setShowProject(true);
  };

  const handleManage = () => {
    const isFromProfile = location.pathname.startsWith('/perfil/');
    if (isFromProfile && myPerson && userData && currentTab) {
      const userName = userData.type === "COMPANY" 
        ? userData.razon_social 
        : `${userData.name} ${userData.last_name}`;
      const sectionForNav =
        currentTab === 'Gestión' ? gestionNavSection ?? 'proyectos' : null;
      const params = buildNavigationParams(
        currentTab as string,
        String(userData.id),
        userName,
        sectionForNav
      );
      navigate(`/obrasprivadas/${project.id}${params}`);
    } else {
      navigate(`/obrasprivadas/${project.id}`);
    }
  };

  const handleOpenQuestions = () => {
    if (myPerson) {
      if (questionsNotAnswered.length > 0) {
        setQuestionToAnswer(questionsNotAnswered[0]);
        setShowAnswer(true);
      } else if (totalQuestions > 0) {
        setShowProject(true);
      } else {
        setShowProject(true);
      }
    } else {
      setShowProject(true);
    }
  };

  return (
    <>
      <ProjectItemCard
        project={project}
        myPerson={myPerson}
        onEdit={handleEdit}
        onView={handleView}
        onOpenQuestions={handleOpenQuestions}
        onManage={myPerson ? handleManage : undefined}
        questionsNotAnswered={questionsNotAnswered.length}
        totalQuestions={totalQuestions}
      />

      {showProject && (
        <ProjectModalNew
          project={project}
          myPerson={myPerson}
          userData={userData}
          closeModal={() => setShowProject(false)}
          projectQuestionsForItem={projectQuestionsForItem}
        />
      )}

      {showQuestions && (
        <ProjectQuestions
          projectId={project.id}
          closeModal={() => setShowQuestions(false)}
        />
      )}

      {showAnswer && questionToAnswer && (
        <ProjectAnswer
          projectId={project.id}
          question={questionToAnswer}
          closeModal={() => {
            setShowAnswer(false);
            setQuestionToAnswer(null);
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  projectQuestions: state.profile.projectQuestions || {},
});

export default connect(mapStateToProps, {
  getProjectQuestions,
  openMainModal,
})(ProjectCardWithLogic);
